import Loader from "../../assets/images/preloader.gif";
const PageLoader = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <img src={Loader} alt="Loading..." />
    </div>
  );
};

export default PageLoader;
